import { render } from "./HowToAgent.vue?vue&type=template&id=ab9961b0"
import script from "./HowToAgent.vue?vue&type=script&lang=js"
export * from "./HowToAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__